import type { LucideIcon as LucideIconComponent } from 'lucide-react';
import { resolveSiteIconSize, type SiteIconSizeToken } from './iconSizes';

export type LucideIconType = LucideIconComponent;

export interface LucideIconProps {
  icon: LucideIconComponent;
  size?: number | SiteIconSizeToken;
  strokeWidth?: number;
  className?: string;
  absoluteStrokeWidth?: boolean;
  /** When false, caller must supply accessible name on the control or via title. */
  'aria-hidden'?: boolean;
}

/** Site-template UI icons (menus, map, clock, …). Not for brand/social marks. */
export function LucideIcon({
  icon: Icon,
  size = 'md',
  strokeWidth = 1.5,
  className,
  absoluteStrokeWidth,
  'aria-hidden': ariaHidden = true,
}: LucideIconProps) {
  const px = resolveSiteIconSize(size);
  return (
    <Icon
      size={px}
      strokeWidth={strokeWidth}
      {...(absoluteStrokeWidth ? { absoluteStrokeWidth: true } : {})}
      aria-hidden={ariaHidden}
      className={['ws-icon', className].filter(Boolean).join(' ')}
    />
  );
}
